import { CircularProgress, InputAdornment, IconButton } from '@material-ui/core';
import { FormControl, Popper } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Downshift from 'downshift';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    clearShipperCodes,
    getShipperCodes,
    resetShipperCodeLoaded
} from 'components/TrustCenter/store/actions';
import useDebounce from 'components/TrustCenter/UI/Debounce/Debounce';
import { SPINNER_THEME } from 'components/TrustCenter/VisibilityConnection/ConnectionWizard/AddConnectionMUITheme';
import { isBlank } from 'components/Common/Utils/StringUtils';
import ClearIcon from '@material-ui/icons/Clear';
import { CLEAR_ICON_WIDTH } from 'constants/Constants';
import {
    FILLED_INPUT_FIELD_THEME,
    STD_INPUT_FIELD_THEME
} from 'components/TrustCenter/TrustCenterMuiTheme';

function renderInput(inputProps) {
    const {
        InputProps,
        variant,
        classes,
        helperText,
        error,
        disabled,
        clearInput,
        ref,
        modal,
        allSelected,
        ...other
    } = inputProps;

    return (
        <MuiThemeProvider theme={modal ? FILLED_INPUT_FIELD_THEME : STD_INPUT_FIELD_THEME}>
            <FormControl className="full-width">
                <TextField
                    margin="normal"
                    variant={variant}
                    error={error}
                    disabled={disabled}
                    helperText={helperText}
                    InputProps={{
                        inputRef: ref,
                        ...InputProps,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    disabled={disabled}
                                    onClick={() => clearInput()}
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    {...other}
                />
            </FormControl>
        </MuiThemeProvider>
    );
}

const ShipperCodeSearch = (props) => {
    const {
        classes,
        shipperCodes,
        selectedDataSource,
        shipperCode,
        variant,
        getShipperCodes,
        clearShipperCodes,
        isShipperCodeLoaded,
        resetShipperCodeLoaded,
        allSelected,
        index,
        sendSelectedShipperCode,
        selectedCompanyName,
        selectedShipperCode,
        modal,
        customError,
        disableShipperCodeReset,
        disableOtherOperation,
        userAddedShippers,
        isPremiumGroup
    } = props;

    const [inputValue, setInputValue] = useState('');

    const [selectedItem, setSelectedItem] = useState('');

    const [showSuggestion, setShowSuggestion] = useState(false);

    const [userSearchShipperCode, setUserSearchShipperCode] = useState('');

    const debouncedSearchTerm = useDebounce(userSearchShipperCode, 1000);

    const [touched, setTouched] = useState(false);

    const [prevDatasource, setPrevDatasource] = useState(-1);

    const [popperNode, setPopperNode] = useState({});

    useEffect(() => {
        if (debouncedSearchTerm) {
            getShipperCodes(selectedDataSource, debouncedSearchTerm);
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        if (
            shipperCode !== undefined &&
            shipperCode !== null &&
            Object.keys(shipperCode).length !== 0
        ) {
            setInputValue(shipperCode.company_name + ' - ' + shipperCode.shipper_code);
            setSelectedItem(shipperCode.shipper_code);
        } else {
            setInputValue('');
            setSelectedItem('');
            setTouched(false);
        }
    }, [shipperCode]);

    useEffect(() => {
        if (
            selectedCompanyName !== undefined &&
            selectedShipperCode !== undefined &&
            selectedCompanyName !== '' &&
            selectedShipperCode !== ''
        ) {
            setInputValue(selectedCompanyName + ' - ' + selectedShipperCode);
            setSelectedItem(selectedShipperCode);
        }
    }, [selectedCompanyName, selectedShipperCode]);

    useEffect(() => {
        if (prevDatasource > 0) {
            if (!disableShipperCodeReset || isBlank(selectedDataSource)) {
                resetShipperCodeLoaded();
                setUserSearchShipperCode('');
                clearShipperCodes();
                setInputValue('');
                sendSelectedShipperCode({}, index);
                setSelectedItem('');
                setTouched(false);
            }
        } else {
            setPrevDatasource(selectedDataSource);
        }
    }, [selectedDataSource]);

    useEffect(() => {
        if (allSelected) {
            clearInput();
        }
    }, [allSelected]);

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            if (temp !== '') {
                handleChange(temp);
            }
        }
    }

    function handleInputChange(event) {
        setInputValue(event.target.value);
        setTouched(true);
        if (selectedItem !== '') {
            sendSelectedShipperCode({}, index);
            setSelectedItem('');
        }
        if (event.target.value.length >= 3) {
            setUserSearchShipperCode(event.target.value);
            setShowSuggestion(true);
        } else {
            resetShipperCodeLoaded();
            setUserSearchShipperCode('');
            clearShipperCodes();
            setShowSuggestion(false);
        }
    }

    const validationSelectedItem = (isOpen) => {
        return (
            (selectedItem === '' && !isOpen && touched) ||
            (selectedItem !== '' &&
                customError !== undefined &&
                customError.length > 0 &&
                !showSuggestion)
        );
    };

    const getHelperText = (isOpen) => {
        if (
            selectedItem !== '' &&
            customError !== undefined &&
            customError.length > 0 &&
            !showSuggestion
        ) {
            return customError;
        }
        if (validationSelectedItem(isOpen)) {
            return 'Enter 3 or more characters and Choose a shipper';
        } else {
            return 'Enter 3 or more characters';
        }
    };

    let temp = '';

    function renderSuggestion(suggestionProps) {
        const { suggestion, index, itemProps, highlightedIndex, selectedItem } = suggestionProps;
        const isHighlighted = highlightedIndex === index;
        const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;
        if (isHighlighted) {
            temp = suggestion;
        }

        let isPresent =
            userAddedShippers !== undefined
                ? userAddedShippers.some(function (el) {
                      return (
                          el.shipperCode.shipper_code === suggestion.shipper_code &&
                          el.datasource.id === suggestion.datasource_id
                      );
                  })
                : false;

        if (!isPresent) {
            return (
                <MenuItem
                    {...itemProps}
                    key={index}
                    selected={isHighlighted}
                    component="div"
                    onClick={() => handleChange(suggestion)}
                    style={{
                        fontWeight: isSelected ? 500 : 400
                    }}
                >
                    {suggestion.company_name} - {suggestion.shipper_code}
                </MenuItem>
            );
        } else {
            return null;
        }
    }

    const handleChange = (item) => {
        setShowSuggestion(false);

        if (item) {
            // addShipperCode(item);
            let newSelectedItem = item.company_name + ' - ' + item.shipper_code;
            setSelectedItem(item.shipper_code);
            setInputValue(newSelectedItem);
            sendSelectedShipperCode(item, index);
        }
    };

    const clearInput = () => {
        setSelectedItem('');
        setInputValue('');
        sendSelectedShipperCode({}, index);
        setTouched(false);
    };

    function getSuggestions() {
        let totalList = shipperCodes;

        if (shipperCodes === undefined) {
            totalList = [];
        }

        return totalList;
    }

    function disableInput() {
        return isBlank(selectedDataSource) || disableOtherOperation;
    }

    return (
        <div>
            <Downshift
                id="downshift-multiple"
                inputValue={inputValue}
                onChange={() => handleChange()}
                selectedItem={selectedItem}
            >
                {({
                    getInputProps,
                    getItemProps,
                    getLabelProps,
                    isOpen,
                    getMenuProps,
                    inputValue: inputValue2,
                    selectedItem: selectedItem2,
                    highlightedIndex
                }) => {
                    const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
                        onKeyDown: handleKeyDown,
                        placeholder: ''
                    });

                    return (
                        <div className={classes.container}>
                            {renderInput({
                                fullWidth: true,
                                classes,
                                variant: variant,
                                label: 'Find Shipper',
                                helperText: getHelperText(isOpen),
                                error: validationSelectedItem(isOpen),
                                disabled: allSelected || disableInput() || isPremiumGroup(),
                                clearInput: clearInput,
                                InputLabelProps: getLabelProps(),
                                InputProps: getInputProps({
                                    onChange: (event) => {
                                        handleInputChange(event);
                                        onChange(event);
                                    },
                                    onBlur: (event) => {
                                        setShowSuggestion(false);
                                    },
                                    onKeyDown: handleKeyDown
                                }),
                                inputProps,
                                ref: (node) => {
                                    setPopperNode(node);
                                },
                                modal: modal
                            })}
                            {showSuggestion ? (
                                isShipperCodeLoaded ? (
                                    <Popper
                                        open={showSuggestion}
                                        anchorEl={popperNode}
                                        style={{
                                            position: modal ? 'fixed' : 'absolute',
                                            marginTop: 5,
                                            minWidth: popperNode
                                                ? popperNode.clientWidth + CLEAR_ICON_WIDTH
                                                : undefined,
                                            width: 'max-content',
                                            zIndex: 1500000
                                        }}
                                    >
                                        <Paper className={classes.paper} square>
                                            {getSuggestions().length > 0 && isShipperCodeLoaded ? (
                                                getSuggestions().map((suggestion, index) =>
                                                    renderSuggestion({
                                                        suggestion,
                                                        index,
                                                        itemProps: getItemProps({
                                                            item: suggestion.label
                                                        }),
                                                        highlightedIndex,
                                                        selectedItem: selectedItem2
                                                    })
                                                )
                                            ) : (
                                                <MenuItem component="div">
                                                    (No Shipper codes found)
                                                </MenuItem>
                                            )}
                                        </Paper>
                                    </Popper>
                                ) : (
                                    <Popper
                                        open={showSuggestion}
                                        anchorEl={popperNode}
                                        style={{
                                            position: modal ? 'fixed' : 'absolute',
                                            marginTop: 5,
                                            minWidth: popperNode
                                                ? popperNode.clientWidth
                                                : undefined,
                                            width: 'max-content',
                                            zIndex: 1500000
                                        }}
                                    >
                                        <Paper className={classes.spinnerPaper} square>
                                            <MuiThemeProvider theme={SPINNER_THEME}>
                                                <CircularProgress />
                                            </MuiThemeProvider>
                                        </Paper>
                                    </Popper>
                                )
                            ) : null}
                        </div>
                    );
                }}
            </Downshift>
        </div>
    );
};

ShipperCodeSearch.propTypes = {
    classes: PropTypes.object.isRequired
};

const styles = (theme) => ({
    paper: {
        zIndex: 1500,
        maxHeight: 200,
        overflow: 'scroll'
    },
    spinnerPaper: {
        zIndex: 1500,
        maxHeight: 200
    },
    inputRoot: {
        flexWrap: 'wrap',
        height: '90px',
        overflow: 'scroll'
    },
    hr: {
        marginTop: '-0.6rem',
        borderBottom: '2px solid #303f9f'
    }
});

function IntegrationDownshift(props) {
    return <ShipperCodeSearch {...props} />;
}

IntegrationDownshift.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    shipperCodes: state.agreement.shipperCodes,
    isShipperCodeLoaded: state.agreement.isShipperCodeLoaded,
    disableOtherOperation: state.agreement.disableOtherOperation
});

export default connect(mapStateToProps, {
    getShipperCodes,
    clearShipperCodes,
    resetShipperCodeLoaded
})(withStyles(styles)(IntegrationDownshift));
